const CONTROL_WHITESPACE = /[\t\n\r\f\v]/g;
const UUID_DASHES = /-/g;

/**
 * Strips the control whitespace a scanner appends to a barcode so the value is
 * safe to compare and to send to the barcode endpoint. Idempotent.
 */
export const normalizeBarcodeValue = (barcodeValue: string) =>
  barcodeValue.replace(CONTROL_WHITESPACE, '').trim();

/**
 * Drops the dashes the barcode endpoint returns in its uuids so they match the
 * undashed `object_id` Orders V2 uses. Idempotent.
 */
export const normalizeObjectId = (objectId: string) => objectId.replace(UUID_DASHES, '');
